import { Blogs } from "../../../../../components/backgrounds/Blogs";

export function PorQueNegaronPage() {
  return (
    <>
      <Blogs
        title={"¿Por qué Galilea negó mi solicitud?"}
        content={
          <>
            <div className="pt-6 opacity-60 text-xl">
              <p className="">
                Hola astronauta, si tienes dudas sobre tu proceso de solicitud y
                no sabes porque negamos un préstamo, aquí te contamos porqué.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-xl lg:text-2xl font-light">
                <a href="/registrarse" className="text-purple hover:underline">
                  Si aún no has solicitado tu crédito en Galilea da clic aquí.
                </a>
              </span>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                Para aceptar una solicitud de préstamo debemos indagar un par de
                cosas sobre ti antes de poder otorgarlo, una relación financiera
                se construye poco a poco con tiempo y paciencia, por esto,
                nuestros Galileos consultan y procesan más de 400 variables que
                se obtienen con previa autorización del titular.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                ¿Dónde revisan mis datos personales?
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Además de investigar estos datos también consultamos en bases de
                datos oficiales, seguramente has oído hablar de Datacrédito,
                Cifin o Mareigüa, centrales de riesgo que se encargan de
                almacenar y suministrar información sobre el comportamiento
                financiero de las personas. Gracias a la información que
                recolectamos podemos saber si estás listo para acceder a un
                crédito.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-xl lg:text-2xl font-light pt-10">
                <a href="/datos" className="text-purple hover:underline">
                  Si tienes dudas sobre cómo tratamos tus datos personales
                  revisa nuestra política aquí.
                </a>
              </span>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                En Galilea otorgamos créditos de manera responsable
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Esto lo hacemos porque en Galilea queremos ayudar a las personas
                a mejorar su vida financiera, lo que menos queremos es generar
                una afectación en su historial crediticio.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                En el mundo Galilea conoces más y mejores formas de mejorar tu
                perfil crediticio y pertenecer al sistema financiero de una
                manera responsable trayendo bienestar a tu vida.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                ¿Qué puedo hacer entonces para que Galilea apruebe mi crédito?
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                El mejor consejo que podemos darte es que revises tu situación
                creditica en centrales de riesgo, tu nivel de ingresos o
                endeudamiento, y que empieces a trabajar sobre aquellos puntos
                que están causando que neguemos tu crédito, si te sientes listo
                para volverlo a intentar, puedes visitarnos dentro de 90 días
                para revisar tu información nuevamente.
              </p>
            </div>
          </>
        }
        enlace1={
          <a
            href="/blog/como-mejorar-mi-puntaje-en-datacredito"
            className="text-purple hover:underline"
          >
            ¿Cómo mejorar mi puntaje de crédito?
          </a>
        }
        enlace2={
          <a href="#" className="text-purple hover:underline">
            6 consejos para manejar tus finanzas personales
          </a>
        }
        enlace3={
          <a href="#" className="text-purple hover:underline">
            Apps para controlar tus finanzas personales
          </a>
        }
      />
    </>
  );
}
